<!--
 * @Author: 汪俊洪
 * @Date: 2022-10-17 19:00:43
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2022-10-20 14:48:20
 * @Description: 订单评价
-->
<template>
  <div class="rate-wrap">
    <el-form :model="input" :rules="rules" ref="input">
      <el-form-item :label="`${$t('ordervote.no')}：`">
        {{ detail.orderCode || '-' }}
      </el-form-item>
      <el-form-item :label="`${$t('ordervote.allof')}：`" prop="overallScore">
        <el-rate v-model="input.overallScore"></el-rate>
      </el-form-item>
      <div class="divider"></div>
      <div class="rates">
        <el-form-item :label="`${$t('ordervote.quality')}：`" prop="qualityScore">
          <el-rate v-model="input.qualityScore"></el-rate>
        </el-form-item>
        <el-form-item :label="`${$t('ordervote.feedback')}：`" prop="deliveryScore">
          <el-rate v-model="input.deliveryScore"></el-rate>
        </el-form-item>
        <el-form-item :label="`${$t('ordervote.service')}：`" prop="serviceScore">
          <el-rate v-model="input.serviceScore"></el-rate>
        </el-form-item>
        <el-form-item :label="`${$t('ordervote.price')}：`" prop="priceScore">
          <el-rate v-model="input.priceScore"></el-rate>
        </el-form-item>
      </div>
      <el-form-item :label="`${$t('ordervote.discribe')}：`" prop="remark">
        <el-input
          type="textarea"
          :placeholder="$t('ordervote.placeholder')"
          v-model="input.remark"
          maxlength="500"
          :autosize="{ minRows: 3, maxRows: 6 }"
          show-word-limit
        ></el-input>
      </el-form-item>
      <el-form-item prop="payOrderItemEvaluationList">
        <el-table
          :data="showList"
          height="350"
          border
          :stripe="true"
          style="width: 100%"
        >
          <el-table-column prop="goodsCode" show-overflow-tooltip :label="`${$t('ordervote.orderCode')}：`">
          </el-table-column>
          <el-table-column prop="goodsName" show-overflow-tooltip :label="`${$t('ordervote.productName')}：`">
          </el-table-column>
          <el-table-column prop="goodsModel" show-overflow-tooltip :label="`${$t('ordervote.model')}：`"> </el-table-column>
          <el-table-column prop="address" :label="`${$t('ordervote.rate')}：`">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.overallScore" @change="() => changeOverallScore(scope.$index,scope.row.overallScore)"></el-rate>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </el-form-item>
      <el-form-item label="" class="align-center">
        <el-button
          class="default-btn"
          :loading="butLoading"
          @click="handleClose"
          size="small"
          >{{$t('cancel')}}</el-button
        >
        <el-button
          type="primary"
          size="small"
          :loading="butLoading"
          @click="handleSubmit"
          style="margin-left: 12px;"
          >{{$t('order.submit')}}</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    total () {
      return this.input.payOrderItemEvaluationList.length
    }
  },
  data () {
    return {
      butLoading: false,
      input: {
        overallScore: 5, // 整体评价
        qualityScore: 5, // 态度评价
        deliveryScore: 5, // 物流评价
        serviceScore: 5, // 物流评价
        priceScore: 5, // 物流评价
        remark: '', // 评价内容
        payOrderItemEvaluationList: []
      },
      rules: {
        overallScore: [{ required: true, message: this.$t('message.select'), trigger: 'change' }],
        qualityScore: [{ required: true, message: this.$t('message.select'), trigger: 'change' }],
        deliveryScore: [{ required: true, message: this.$t('message.select'), trigger: 'change' }],
        serviceScore: [{ required: true, message: this.$t('message.select'), trigger: 'change' }],
        priceScore: [{ required: true, message: this.$t('message.select'), trigger: 'change' }]
      },
      page: {
        page: 1,
        limit: 10
      },
      showList: []
    }
  },
  created () {
    this.input.payOrderItemEvaluationList = this.detail.payOrderItemRefactoryVos.map(
      (v) => {
        v.overallScore = 5
        return v
      }
    )
    this.setPageList()
  },
  methods: {
    changeOverallScore (index, overallScore) {
      const i = (this.page.page - 1) * this.page.limit + index
      this.input.payOrderItemEvaluationList[i].overallScore = overallScore
      this.setPageList()
    },
    // 分页 页码
    handleCurrentChange (val) {
      this.page.page = val
      // 刷新列表数据
      this.setPageList()
    },
    // 分页 每页多少条改变
    handleSizeChange (val) {
      this.page.page = 1
      this.page.limit = val
      // 刷新列表数据
      this.setPageList()
    },
    setPageList (isReset = false) {
      // 重新赋值的列表从第一页开始
      isReset && (this.page.page = 1)
      const start = (this.page.page - 1) * this.page.limit
      const end = this.page.page * this.page.limit
      this.showList = this.input.payOrderItemEvaluationList.slice(start, end)
    },
    handleClose () {
      this.$emit('close')
    },
    handleSubmit () {
      let obj = {
        orderId: this.detail.orderId,
        ...this.input,
        payOrderItemEvaluationList: this.input.payOrderItemEvaluationList.map((v) => {
          return {
            orderItemId: v.orderItemId,
            overallScore: v.overallScore
          }
        })
      }
      this.butLoading = true
      this.$http.post('/front/v1/pay-order-evaluations', obj).then(({ data: res }) => {
        this.butLoading = false
        if (res.code === 0) {
          this.$message.success(this.$t('message.evaluateSuccess'))
          this.$emit('success')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.rate-wrap {
  margin-top: -20px;
  /deep/ .el-form-item__label {
    line-height: 28px;
  }
  /deep/ .el-form-item__content {
    line-height: 28px;
  }
  /deep/ .el-form-item {
    margin-bottom: 12px;
  }
}
.divider {
    height: 1px;
    background: #DCDFE6;
    margin-bottom: 12px;
}
.rates {
    display: flex;
    flex-wrap: wrap;
    >div {
        width: 50%;
    }
}
.align-center {
  text-align: center;
}
</style>
